<script>
    export default {
        data() {
            return {
                data: {},
            }
        },
        mounted() {
            var vm = this;

            vm.load();
        },
        methods: {
            load() {
                var vm = this;

                vm.createEmptyData();
                vm.create();
            },
            createEmptyData() {
                var vm = this;

                var data = {
                    otp: null,
                    digits: ['', '', '', '', '', '']
                };

                vm.data = Object.assign({}, data);
            },
            async create() {
                var vm = this;

                this.$loading.on('verify_email_create');
                try {
                    var resp = await vm.$api.Auth.verifyEmail();
                    var data = resp.data.data;

                    vm.data.email = data.email;

                    this.$loading.off('verify_email_create');
                } catch (err) {
                    if (err.response.data.status == 403 && err.response.data.error == "VERIFIED_EMAIL") {
                        vm.$ac.refresh();
                        vm.$router.push('/');
                    }
                    // this.$flash.error(err.response.data.message);
                }
            },
            _createPostData(data) {
                const otp = data.digits.join('');

                if (otp.length < 6)
                    return;

                data.otp = otp;
                return data;
            },
            async submit() {
                var vm = this;

                try {
                    vm.$loading.on('verify_email_submit');

                    var data = vm._createPostData(vm.data);

                    var resp = await vm.$api.Auth.verifyEmailCreate(data);
                    vm.$ac.refresh();
                    vm.$router.push('/');

                    vm.$flash.success(resp.data.message);
                } catch (error) {
                    vm.$flash.error(error.response.data.message);
                }

                vm.$loading.off('verify_email_submit');
            },
            async resendEmail() {
                var vm = this;

                try {
                    vm.$loading.on('verify_email_resend');

                    var resp = await vm.$api.Auth.verifyEmailResend({});

                    vm.$flash.success(resp.data.message);
                } catch (error) {
                    vm.$flash.error(error.response.data.message);
                }

                vm.$loading.off('verify_email_resend');
            },
            moveToNext(index) {
                if (this.data.digits[index].length === 1) {
                    if (index < this.data.digits.length - 1) {
                        this.$refs['digit' + (index + 1)][0].focus();
                    }
                }
            },
            handleBackspace(event, index) {
                if (event.key === 'Backspace') {
                    if (this.data.digits[index] === '' && index > 0) {
                        this.$refs['digit' + (index - 1)][0].focus();
                    }
                }
            },
            handlePaste(event) {
                event.preventDefault();

                const otp = event.clipboardData
                    .getData('text')
                    .toLowerCase()
                    .replace(/[^a-z0-9]/g, '')
                    .slice(0, this.data.digits.length);

                if (!otp) return;

                // reset dulu
                this.data.digits = Array(this.data.digits.length).fill('');

                // isi OTP
                otp.split('').forEach((char, i) => {
                    this.data.digits[i] = char;
                });

                this.$nextTick(() => {
                    const lastIndex = otp.length - 1;
                    const ref = this.$refs['digit' + lastIndex];

                    if (Array.isArray(ref)) {
                        ref[0]?.focus();
                    } else {
                        ref?.focus();
                    }
                });
            },
            filterInput(index) {
                let val = this.data.digits[index] || '';

                // hanya allow a-z dan 0-9
                val = val.toLowerCase().replace(/[^a-z0-9]/g, '');

                this.data.digits[index] = val;
            },
            async logout() {
                var vm = this;

                try {
                    vm.$loading.on('verify_email_logout');
                    var resp = await vm.$api.Auth.logout();
                    if (!resp.data.is_error) {
                        vm.$api.unsetApiToken();

                        vm.$router.replace({ name: 'login' });

                        vm.$flash.success(resp.data.message);
                    }
                } catch (error) {
                    vm.$flash.error(error.response.data.message);
                }

                vm.$loading.off('verify_email_logout');
            }
        }
    };
</script>

<template>
    <loading :loading="$loading.get('verify_email_create')" variant="dark" type="block">
        <div class="auth-page-wrapper pt-5">
            <div class="auth-one-bg-position auth-one-bg" id="auth-particles">
                <div class="bg-overlay"></div>

                <div class="shape">

                    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink"
                        viewBox="0 0 1440 120">
                        <path d="M 0,36 C 144,53.6 432,123.2 720,124 C 1008,124.8 1296,56.8 1440,40L1440 140L0 140z">
                        </path>
                    </svg>
                </div>
            </div>

            <div class="auth-page-content">
                <BContainer>
                    <BRow>
                        <BCol lg="12">
                            <div class="text-center mt-sm-5 mb-0 text-white-50">
                                <div>
                                    <router-link to="/" class="d-inline-block auth-logo">
                                        <img src="@/assets/images/logo-light.png" alt="" height="40">
                                    </router-link>
                                </div>
                            </div>
                        </BCol>
                    </BRow>

                    <BRow class="justify-content-center">
                        <BCol md="8" lg="6" xl="5">
                            <BCard no-body class="mt-4">

                                <BCardBody class="p-4">
                                    <b-form @submit="submit()">
                                        <div class="mb-4">
                                            <div class="avatar-lg mx-auto">
                                                <div
                                                    class="avatar-title bg-light text-primary display-5 rounded-circle shadow">
                                                    <i class="ri-mail-line"></i>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="p-2 mt-4">
                                            <div class="text-muted text-center mb-4 mx-lg-3">
                                                <skeleton :loading="$loading.get('verify_email_create')"
                                                    :schema="['col-6', 'col-12']">
                                                    <h4>{{ $t('verify_email.label.title') }}</h4>
                                                    <p>
                                                        {{ $t('verify_email.label.sub_title', { email: data.email }) }}
                                                    </p>
                                                </skeleton>
                                            </div>

                                            <b-form @submit="submit">
                                                <BRow>
                                                    <BCol cols="2" v-for="(digit, index) in data.digits" :key="index"
                                                        class="ps-1 pe-1">
                                                        <div class="mb-3">
                                                            <input type="text"
                                                                :disabled="$loading.get('verify_email_create') || $loading.get('verify_email_submit')"
                                                                class="form-control form-control-lg bg-light border-light text-center ps-0 pe-0"
                                                                v-model="data.digits[index]" maxlength="1"
                                                                @keyup="moveToNext(index)" :ref="'digit' + index"
                                                                @keydown="handleBackspace($event, index)"
                                                                @input="filterInput(index)"
                                                                @paste="handlePaste($event, index)">
                                                        </div>
                                                    </BCol>
                                                </BRow>
                                                <div class="mt-3">
                                                    <BButton type="submit" variant="success" class="w-100"
                                                        :disabled="$loading.get('verify_email_submit') || $loading.get('verify_email_create')">
                                                        <loading :loading="$loading.get('verify_email_submit')"
                                                            type="button">
                                                            <i class="mdi mdi-check-all me-1"></i>
                                                            {{ $t('verify_email.btn.send') }}
                                                        </loading>
                                                    </BButton>
                                                </div>
                                            </b-form>
                                            <div class="mt-3">
                                                <BButton type="button" variant="danger" class="w-100" @click="logout"
                                                    :disabled="$loading.get('verify_email_logout')">
                                                    <loading :loading="$loading.get('verify_email_logout')"
                                                        type="button">
                                                        <i class="mdi mdi-logout me-1"></i>
                                                        {{ $t('basic.btn.logout') }}
                                                    </loading>
                                                </BButton>
                                            </div>
                                        </div>
                                    </b-form>
                                </BCardBody>
                            </BCard>

                            <div class="mt-4 text-center">
                                <p class="mb-0">{{ $t('verify_email.label.resend') }}
                                    <router-link to=""
                                        @click.prevent="!$loading.get('verify_email_resend') && resendEmail()"
                                        class="fw-semibold text-primary text-decoration-underline">
                                        {{ $t('verify_email.btn.resend') }}
                                    </router-link>
                                </p>
                            </div>

                        </BCol>
                    </BRow>
                </BContainer>
            </div>

            <footer class="footer">
                <BContainer>
                    <BRow>
                        <BCol lg="12">
                            <div class="text-center">
                                <p class="mb-0 text-muted">&copy; 2026 Cafeman. Seluruh Hak Cipta Dilindungi.</p>
                            </div>
                        </BCol>
                    </BRow>
                </BContainer>
            </footer>
        </div>
    </loading>
</template>